/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'monitor': {
    width: 16,
    height: 16,
    viewBox: '0 0 200 200',
    data: ''
  }
})
